import { useNavigate } from 'react-router-dom'

const useNavigation = () => {
  const navigate = useNavigate()

  return {
    toOrganization: () => navigate('/organization'),
    toOrganizationSSO: (id: number) => navigate(`/organization/${id}/sso`),
    toOrganizationOIDCSSO: (id: number) =>
      navigate(`/organization/${id}/sso/oidc`),
    toOrganizationSAMLSSO: (id: number) =>
      navigate(`/organization/${id}/sso/saml`),
    toLicense: (orgId: number, licenseId: number) =>
      navigate(`/organization/${orgId}/license/${licenseId}`),
    goBack: () => navigate(-1), // Navigate back one entry in the history stack
    toSearch: (query: string) =>
      navigate(`/search?q=${encodeURIComponent(query.trim())}`),
    toPath: (path: string) => navigate(path),
    toSelfProvisioning: (id: number) =>
      navigate(`/organization/${id}/provision`),
  }
}

export default useNavigation
